<template>
  <button
    type="button"
    :disabled="laster"
    class="varsel-knapp ods-margin-right-3 ods-margin-bottom-3 ods-text--weight-regular ods-color-bg-white ods-color-text-blue-dark ods-text--align-left ods-text--size-juliett ods-flex-align-items-center"
    :class="{ 'varsel-knapp--active': varselAktivert }"
    @click="varselAktivert ? $emit('visModal') : $emit('startVarsel')"
  >
    <template v-if="varselAktivert">
      <svg class="varsel-knapp__icon ods-block" viewBox="0 0 32 32" aria-hidden="true">
        <use href="#checkbox-checked"></use>
      </svg>
    </template>
    <template v-else>
      <svg class="varsel-knapp__icon ods-block" viewBox="0 0 32 32" aria-hidden="true">
        <use href="#checkbox"></use>
      </svg>
    </template>
    <span class="varsel-knapp__text">{{ tekst }}</span>
    <ods-spinner v-if="laster" />
  </button>
</template>

<script>
import OdsSpinner from '@/global-components/OdsSpinner.vue';

export default {
  name: 'VarselKnapp',
  components: {
    OdsSpinner,
  },
  props: {
    varselAktivert: {
      type: Boolean,
      required: true,
      default: false,
    },
    laster: {
      type: Boolean,
      default: false,
    },
    beholdertype: {
      type: String,
      required: true,
      default: '',
    },
  },
  computed: {
    tekst() {
      const beholder = this.$t(`abonnementer.abonnementstyper.${this.beholdertype}`).toLowerCase();
      return `Varsel for ${beholder}`;
    },
  },
};
</script>

<style lang="scss">
@use 'sass:map';
@use 'sass:selector';
@use '~@ods/system/colors' as *;

$-module-name: 'varsel-knapp';
.#{$-module-name} {
  $btn-link-bc: $grayscale-20;
  $btn-link-txt: $blue-dark;
  $btn-focus-bg: $white;
  $btn-focus-bc: $blue-state;
  $btn-focus-txt: $blue-state;
  $btn-hover-bg: $white;
  $btn-hover-bc: $blue-state;
  $btn-hover-txt: v$blue-state;
  $btn-active-bg: $blue-state;
  $btn-active-bc: $blue-state;
  $btn-active-txt: $white;
  $btn-disabled-bg: $gray;
  $btn-disabled-bc: $gray;
  $btn-disabled-txt: $grayscale-30;

  border-radius: 0;
  cursor: pointer;
  display: inline-flex;
  flex-direction: row;
  font-family: inherit;
  overflow: hidden;
  position: relative;
  -moz-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  vertical-align: middle;
  border: 2px solid $btn-link-bc;
  text-decoration: none;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
  line-height: 2rem;
  padding: 0.75rem 1rem;

  &__icon {
    --fg-color: currentcolor;

    flex-shrink: 0;
    height: 1.5rem;
    width: 1.5rem;
    margin: 0 0.5rem 0 0;
  }

  &:link,
  &:visited {
    color: $btn-link-txt;
  }

  a.#{$-module-name}:focus,
  &:enabled:focus,
  &.#{$-module-name}--focus {
    background-color: $btn-focus-bg;
    border-color: $btn-focus-bc;
    color: $btn-focus-txt;
    outline: 0;
    text-decoration: underline;
  }

  a.#{$-module-name}:hover,
  &:enabled:hover,
  &.#{$-module-name}--hover {
    background-color: $btn-hover-bg;
    border-color: $btn-hover-bc;
    color: $btn-hover-txt;
    outline: 0;
    text-decoration: underline;
  }

  a.#{$-module-name}:active,
  &:enabled:active,
  &.#{$-module-name}--active,
  &.#{$-module-name}--active:hover {
    $btn-link-bc: $grayscale-20;
    $btn-link-txt: $blue-dark;
    $btn-focus-bg: $white;
    $btn-focus-bc: $blue-state;
    $btn-focus-txt: $blue-state;
    $btn-hover-bg: $white;
    $btn-hover-bc: $blue-state;
    $btn-hover-txt: $blue-state;
    $btn-active-bg: #f2f9ff;
    $btn-active-bc: $blue-state;
    $btn-active-txt: $blue-state;
    $btn-disabled-bg: $gray;
    $btn-disabled-bc: $gray;
    $btn-disabled-txt: $grayscale-30;

    background-color: $btn-active-bg;
    border-color: $btn-active-bc;
    color: $btn-active-txt;
    outline: 0;
    text-decoration: none;
  }

  &:disabled {
    background-color: $btn-disabled-bg;
    border-color: $btn-disabled-bc;
    color: $btn-disabled-txt;
    cursor: inherit;
  }
}
</style>
